'use client'

import React from 'react'
import { ToastContainer, toast, ToastOptions } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import CheckCircle from '@sylveraio/untitled-ui-icons-react/build/esm/CheckCircle'
import XClose from '@sylveraio/untitled-ui-icons-react/build/esm/XClose'

import { ToastContentProps, ToastProps } from './types'

export const ToastContent: React.FC<ToastContentProps> = ({
  icon = (
    <CheckCircle
      width={20}
      height={20}
      className="text-content-positive-default"
    />
  ),
  title,
  subtitle,
  onClose,
}) => (
  <div className="flex items-start text-subtle space-x-3">
    <div className="text-lg">{icon}</div>
    <div className="flex flex-col gap-2">
      <p className="font-bold text-default text-sm">{title}</p>
      <p className="text-xs text-gray-500">{subtitle}</p>
    </div>
    <button
      className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
      onClick={onClose}
      aria-label="Close"
    >
      <XClose width={20} height={20} />
    </button>
  </div>
)

export const showToast = (
  title: string,
  subtitle: string,
  icon?: React.ReactNode,
  options?: ToastOptions,
) => {
  toast(
    <ToastContent
      icon={icon}
      title={title}
      subtitle={subtitle}
      onClose={() => toast.dismiss()}
    />,
    options,
  )
}

export const Toast: React.FC<ToastProps> = ({
  position = 'top-right',
  autoClose = 5000,
  ...props
}) => {
  return (
    <ToastContainer
      position={position}
      autoClose={autoClose}
      closeButton={false}
      hideProgressBar
      toastClassName={() =>
        'relative flex items-center p-4 rounded-lg shadow-lg bg-white border border-gray-200 w-96 border border-default'
      }
      {...props}
    />
  )
}
